module.exports = __webpack_public_path__ + "img/logo-icon.0560226b.png";